export default "__VITE_ASSET__CHmQDQn2__"